import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  DateRangPickerField,
} from "../../../_metronic/_partials/controls";
import { Col, Row, Button, Accordion } from "react-bootstrap";
import moment from "moment";

import * as actions from "./_redux/Actions";
import {
  dateFormatCol,
  dateTimeFormatCol,
} from "../../components/column-formatters";
import * as UIHelpers from "../../components/UIHelpers";
import "./ContestList.css";

export default function ContestDetails(props) {
  const dispatch = useDispatch();

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const { actionsLoading, contestData, allocatedUserList } = currentState;

  const [isShowSectionIDPass, setIsShowSectionIDPass] = useState(false);
  const [isShowSectionSS, setIsShowSectionSS] = useState(false);
  const [isShowSectionWin, setIsShowSectionWin] = useState(false);
  const [isShowSectionIssue, setIsShowSectionIssue] = useState(false);
  const [isShowSectionDetails, setIsShowSectionDetails] = useState(false);

  const [contestDateTime, setContestDateTime] = useState(undefined);

  useEffect(() => {
    var id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    dispatch(actions.fetchContestViewDetails(id));
  }, []);

  useEffect(() => {
    console.log("contestData: ", contestData?.data?.gameAry?.name);

    if (contestData && contestData?.data && contestData?.data?.matchTime) {
      const date = moment(contestData?.data?.matchDate).format("y-MM-DD");
      const time = moment(contestData?.data?.matchTime).format("HH:mm:ss");
      const formate = "YYYY-MM-DD h:m A";
      // var dateTime = new Date(date + ' ' + time);
      var dateTime = moment(date + " " + time);
      setContestDateTime(dateTime);
    }

    let totalPlayers = 0,
      gameTypePlayer = 1;
    if (contestData?.data?.gameTypeAry) {
      gameTypePlayer = contestData.data.gameTypeAry.players;
    }
  }, [contestData]);

  const DiffTime = (data) => {
    const type = data.type;
    const dateTime = data.dateTime;
    let startTime;
    let endTime;
    if (type === "RPTime") {
      endTime = moment(dateTime)
        .subtract(15, "minutes")
        .format("hh:mm a");
      startTime = moment(dateTime)
        .subtract(15, "minutes")
        .subtract(contestData?.data?.gameTypeAry?.settings?.RPTime, "minutes")
        .format("hh:mm a");
      // console.log(contestData?.data?.gameTypeAry?.settings?.RPTime)
      return startTime + " to " + endTime;
    }
    if (type === "SSTime") {
      startTime = moment(dateTime).format("hh:mm a");
      endTime = moment(dateTime)
        .add(contestData?.data?.gameTypeAry?.settings?.SSUploadTime, "minutes")
        .format("hh:mm a");
      // console.log(startTime, dateTime, endTime);
      return startTime + " to " + endTime;
    }

    if (type === "WDTime") {
      startTime = moment(dateTime).format("hh:mm a");
      endTime = moment(dateTime)
        .add(contestData?.data?.gameTypeAry?.settings?.winningsTime, "minutes")
        .format("hh:mm a");
      return startTime + " to " + endTime;
    }
    return null;
  };

  const DiffTimeBadge = (data) => {
    // console.log("data dddddddd:", data);
    const type = data.type;
    const dateTime = data.dateTime;
    const formate = "YYYY-MM-DD h:m A";
    let startTime;
    let endTIme;
    // console.log("startTime:", startTime);

    if (!data.updateTime) {
      return (
        <span className="badge badge-info badge-pill badge-inline mr-2">
          Pending
        </span>
      );
    } else {
      const updateTime = moment(data.updateTime, formate);
      if (type === "RPTime") {
        endTIme = moment(moment(dateTime).subtract(15, "minutes"), formate);
        startTime = moment(
          moment(dateTime)
            .subtract(15, "minutes")
            .subtract(
              contestData?.data?.gameTypeAry?.settings?.RPTime,
              "minutes"
            ),
          formate
        );
      }
      if (type === "SSTime") {
        startTime = moment(moment(dateTime), formate);
        endTIme = moment(
          moment(dateTime).add(
            contestData?.data?.gameTypeAry?.settings?.SSUploadTime,
            "minutes"
          ),
          formate
        );
      }

      if (type === "WDTime") {
        startTime = moment(moment(dateTime).format("h:m A"), formate);
        endTIme = moment(
          moment(dateTime).add(
            contestData?.data?.gameTypeAry?.settings?.winningsTime,
            "minutes"
          ),
          formate
        );
      }

      if (
        updateTime.isBetween(startTime, endTIme) ||
        updateTime.isBefore(endTIme)
      ) {
        return (
          <span className="badge badge-success badge-pill badge-inline mr-2">
            On Time
          </span>
        );
      }
      if (updateTime.isAfter(endTIme)) {
        return (
          <span className="badge badge-danger badge-pill badge-inline mr-2">
            Delayed
          </span>
        );
      }
      if (updateTime.isBefore(startTime)) {
        return (
          <span className="badge badge-danger badge-pill badge-inline mr-2">
            Earlly
          </span>
        );
      }
    }

    return null;
  };

  const createCardStats = () => {
    return (
      <Row>
        <Col xl={3} sm={6} col={12} className="mb-4">
          <Accordion>
            <Card className={"bg-transparent text-center contestCard"}>
              <div className="card-content text-white bg-primary card_border_top ">
                <div className="card-body">
                  <h4 className="card-title text-uppercase text-white m-0 d-flex justify-content-between align-items-center">
                    <div></div>
                    <div>Room ID / Password</div>
                    <Accordion.Toggle as={Button} variant="link" eventKey="1">
                      <span className="">
                        <i
                          className={`${
                            isShowSectionIDPass
                              ? "fas fa-chevron-circle-up"
                              : "fas fa-chevron-circle-down"
                          } icon-lg text-light ml-3`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsShowSectionIDPass(!isShowSectionIDPass);
                          }}
                        ></i>
                      </span>
                    </Accordion.Toggle>
                  </h4>
                  <Accordion.Collapse eventKey="1">
                    <div className="card-content min-h-90px mt-5">
                      {/* max-h-90px */}
                      <small className="card-text">
                        Please share room details in following time interval to
                        prevent cancellation of a tournament.
                      </small>
                    </div>
                  </Accordion.Collapse>
                </div>
              </div>
              {/* {contestDateTime && ( */}
              <div className="card-stacked bg-white card_border_bottom p-3 min-h-70px max-h-70px">
                <div className="px-3">
                  <h5 className="card-text text-dark font-weight-bold text-uppercase ">
                    <DiffTime
                      dateTime={contestDateTime}
                      type="RPTime"
                      item={contestData?.data}
                    />
                  </h5>
                  <DiffTimeBadge
                    dateTime={contestDateTime}
                    updateTime={contestData?.data?.rpUploadTime}
                    type="RPTime"
                    item={contestData.data}
                  />
                </div>
              </div>
              {/* // )} */}
            </Card>
          </Accordion>
        </Col>
        <Col xl={3} sm={6} col={12} className="mb-4">
          <Accordion>
            <Card
              className={"bg-transparent text-center contestCard card_border"}
            >
              <div className="card-content text-white bg-warning card_border_top ">
                <div className="card-body">
                  <h4 className="card-title text-uppercase text-white m-0 d-flex justify-content-between align-items-center">
                    <div></div>
                    <div>Screenshot Upload</div>
                    <Accordion.Toggle as={Button} variant="link" eventKey="2">
                      <span className="">
                        <i
                          className={`${
                            isShowSectionSS
                              ? "fas fa-chevron-circle-up"
                              : "fas fa-chevron-circle-down"
                          } icon-lg text-light ml-3`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsShowSectionSS(!isShowSectionSS);
                          }}
                        ></i>
                      </span>
                    </Accordion.Toggle>
                  </h4>
                  <Accordion.Collapse eventKey="2">
                    <div className="card-content min-h-90px mt-5">
                      {/* max-h-90px */}
                      <small className="card-text">
                        Please upload screenshots of the InGame users ranking in
                        following time interval to prevent cancellation of a
                        tournament.
                      </small>
                    </div>
                  </Accordion.Collapse>
                </div>
              </div>
              {/* {contestDateTime && ( */}
              <div className="card-stacked bg-white card_border_bottom p-3 min-h-70px max-h-70px">
                <div className="px-3">
                  <h5 className="card-text text-dark font-weight-bold text-uppercase">
                    <DiffTime
                      dateTime={contestDateTime}
                      type="SSTime"
                      item={contestData.data}
                    />
                  </h5>
                  <DiffTimeBadge
                    dateTime={contestDateTime}
                    updateTime={contestData?.data?.ssUploadTime}
                    type="SSTime"
                    item={contestData?.data}
                  />
                </div>
              </div>
              {/* )} */}
            </Card>
          </Accordion>
        </Col>
        <Col xl={3} sm={6} col={12} className="mb-4">
          <Accordion>
            <Card className={"bg-transparent text-center contestCard"}>
              <div className="card-content text-white bg-info card_border_top ">
                <div className="card-body">
                  <h4 className="card-title text-uppercase text-white m-0 d-flex justify-content-between align-items-center">
                    <div></div>
                    <div>WINNING UPLOAD</div>
                    <Accordion.Toggle as={Button} variant="link" eventKey="3">
                      <span className="">
                        <i
                          className={`${
                            isShowSectionWin
                              ? "fas fa-chevron-circle-up"
                              : "fas fa-chevron-circle-down"
                          } icon-lg text-light ml-3`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsShowSectionWin(!isShowSectionWin);
                          }}
                        ></i>
                      </span>
                    </Accordion.Toggle>
                  </h4>
                  <Accordion.Collapse eventKey="3">
                    <div className="card-content min-h-90px mt-5">
                      {/* max-h-90px */}
                      <small className="card-text">
                        Please update winning of the InGame users ranking in
                        following time interval to prevent cancellation of a
                        tournament.
                      </small>
                    </div>
                  </Accordion.Collapse>
                </div>
              </div>
              {/* {contestDateTime && ( */}
              <div className="card-stacked bg-white card_border_bottom p-3 min-h-70px max-h-70px">
                <div className="px-3">
                  <h5 className="card-text text-dark font-weight-bold text-uppercase">
                    <DiffTime dateTime={contestDateTime} type="WDTime" />
                  </h5>
                  <DiffTimeBadge
                    dateTime={contestDateTime}
                    updateTime={contestData?.data?.updateWinningsTime}
                    type="WDTime"
                  />
                </div>
              </div>
              {/* )} */}
            </Card>
          </Accordion>
        </Col>
        {/* <Col xl={3} sm={6} col={12} className="mb-4">
              <Accordion>
                <Card className={"bg-transparent text-center contestCard"}>
                  <div className="card-content text-white bg-info card_border_top ">
                    <div className="card-body">
                      <h4 className="card-title text-uppercase text-white m-0 d-flex justify-content-between align-items-center">
                        <div></div>
                        <div>WINNING UPLOAD</div>
                        <Accordion.Toggle as={Button} variant="link" eventKey="3">
                          <span className="">
                            <i
                              className={`${
                                isShowSectionWin
                                  ? "fas fa-chevron-circle-up"
                                  : "fas fa-chevron-circle-down"
                              } icon-lg text-light ml-3`}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setIsShowSectionWin(!isShowSectionWin);
                              }}
                            ></i>
                          </span>
                        </Accordion.Toggle>
                      </h4>
                      <Accordion.Collapse eventKey="3">
                        <div className="card-content min-h-90px mt-5">
                          <small className="card-text">
                            Please update winning of the InGame users ranking in
                            following time interval to prevent cancellation of a
                            tournament.
                          </small>
                        </div>
                      </Accordion.Collapse>
                    </div>
                  </div>
                  <div className="card-stacked bg-white card_border_bottom p-3 min-h-70px max-h-70px">
                    <div className="px-3">
                      <h5 className="card-text text-dark font-weight-bold text-uppercase">
                        <DiffTime dateTime={contestDateTime} type="WDTime" />
                      </h5>
                      <DiffTimeBadge
                        dateTime={contestDateTime}
                        updateTime={contestData?.data?.updateWinningsTime}
                        type="WDTime"
                      />
                    </div>
                  </div>
                </Card>
              </Accordion>
            </Col> */}
        {/* <Col xl={3} sm={6} col={12} className="mb-4">
              <Accordion>
                <Card className={"bg-transparent text-center contestCard"}>
                  <div className="card-content text-white bg-danger card_border_top ">
                    <div className="card-body">
                      <h4 className="card-title text-uppercase text-white m-0 d-flex justify-content-between align-items-center">
                        <div></div>
                        <div>ISSUE / RATING</div>
                        <Accordion.Toggle as={Button} variant="link" eventKey="4">
                          <span className="">
                            <i
                              className={`${
                                isShowSectionIssue
                                  ? "fas fa-chevron-circle-up"
                                  : "fas fa-chevron-circle-down"
                              } icon-lg text-light ml-3`}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setIsShowSectionIssue(!isShowSectionIssue);
                              }}
                            ></i>
                          </span>
                        </Accordion.Toggle>
                      </h4>
                      <Accordion.Collapse eventKey="4">
                        <div className="card-content min-h-90px mt-5">
                          <small className="card-text">
                            It is showing count of the reported issue and submited
                            rating by user.
                          </small>
                        </div>
                      </Accordion.Collapse>
                    </div>
                  </div>
                  <div className="card-stacked bg-white card_border_bottom p-3 min-h-70px max-h-70px">
                    <div className="px-3">
                      <h5 className="card-text text-dark font-weight-bold text-uppercase">
                         NA
                      </h5>
                      <span className="badge  badge-pill badge-inline mr-2">
                        NA
                      </span>
                    </div>
                  </div>
                </Card>
              </Accordion>
            </Col> */}
      </Row>
    );
  };

  const createWinnersDropdown = () => {
    return (
      <div className={`align-items-center bg-white ${props?.className}`}>
        <div className="w-100">
          <div className="d-flex" style={{ flexDirection: "column" }}>
            <div className="dropdown dropdown-inline show data_table_main_dropdown">
              <button
                type="button"
                tabIndex="-1"
                data-toggle="dropdown"
                role="combobox"
                className="btn dropdown-toggle btn-light bs-placeholder data_table_dropdown_button"
                aria-owns="bs-select-1"
                aria-haspopup="listbox"
                aria-expanded="false"
                data-id="kt_datatable_search_status"
                title="All"
              >
                <div className="filter-option" style={{ overflow: "hidden" }}>
                  <div className="filter-option-inner">
                    <div className="filter-option-inner-inner">
                      {contestData?.data?.winnerCount}
                    </div>
                  </div>
                </div>
              </button>

              <div
                className="dropdown-menu dropdown-menu-xl"
                style={{
                  width: "500px",
                  minWidth: "175px",
                  maxHeight: "450px",
                  overflow: "auto",
                  position: "absolute",
                  willChange: "transform",
                  top: "0px",
                  left: "0px",
                  transform: "translate3d(0px, 40px, 0px)",
                }}
                // x-placement="bottom-end"
              >
                <ul className="navi flex-column navi-hover py-2">
                  <li className="navi-item border-bottom">
                    <a className={`navi-link`}>
                      <span className="navi-text row m-0">
                        <div className="col">Rank</div>
                        <div className="col">Amount</div>
                        <div className="col">Total Amount</div>
                      </span>
                    </a>
                  </li>
                  {contestData?.data?.tournamentAry?.winningTerm !== "perKill"
                    ? contestData?.data?.tournamentAry?.prizePooInfo.map(
                        (prizepoolItem, i) => (
                          <li
                            className="navi-item border-bottom"
                            key={i}
                            value={prizepoolItem._id}
                          >
                            <a className={`navi-link`}>
                              <span className="navi-text row m-0">
                                <div className="col">
                                  {prizepoolItem?.rankFrom}
                                  {" To "}
                                  {prizepoolItem?.rankTo}
                                  {/* {
                                    parseInt(prizepoolItem?.rankTo) !== 0 &&
                                    <> - {prizepoolItem?.rankTo}</>
                                  } */}
                                </div>
                                <div className="col">
                                  {prizepoolItem?.amount}
                                </div>
                                <div className="col">
                                  {prizepoolItem?.totalAmount}
                                </div>
                              </span>
                            </a>
                          </li>
                        )
                      )
                    : ""}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const createBasicDetails = () => {
    return (
      <div className="mb-4">
        <Accordion>
          <div className="card card-custom gutter-b card_border">
            <div
              className="card-header ribbon ribbon-top ribbon-ver"
              style={{
                backgroundColor: "var(--color_black)",
                borderRadius: isShowSectionDetails ? "16px 16px 0 0" : "16px",
                transition: "border-radius 1s",
              }}
            >
              {/* Ribbon */}
              <div
                className="ribbon-target"
                style={{ top: "-5px", right: "80px", height: "40px" }}
              >
                <span
                  className={`ribbon-inner bg-${
                    contestData?.data?.status === "cancelled"
                      ? "danger"
                      : "warning"
                  }`}
                  style={{ borderRadius: "0 0 8px 8px" }}
                ></span>

                {/* {
                        userData.mobileVerified === true ?
                            <i className="flaticon2-correct text-dark font-size-h5 mr-2"></i>
                            :
                            <i className="fas fa-exclamation-circle text-danger font-size-h5 mr-2"></i>
                        } */}
                <div className="up_bp_app_installed">
                  Status: {contestData?.data?.status}
                </div>
              </div>

              {/* Title */}
              <div className="card-title text-white w-100 d-flex flex-column">
                <div className="w-100 mt-5 pt-5">
                  <div className="row w-100 m-0">
                    <div className="col-11 p-0">
                      <div className="row w-100 m-0">
                        <div className="col-xl-3 col-sm-6 col-12 mb-3">
                          <div className="d-flex align-items-center mr-14">
                            <span className="mr-6">
                              <i
                                className="fa fa-gamepad text-muted"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </span>
                            <div className="d-flex flex-column flex-lg-fill text-white">
                              <div
                                className="text-white font-weight-bolder"
                                style={{ fontSize: "20px" }}
                              >
                                {contestData?.data?.gameAry?.name &&
                                  contestData?.data?.gameAry?.name}{" "}
                                -{" "}
                                {contestData?.data &&
                                  contestData?.data?.gameTypeAry?.name}
                              </div>
                              <span
                                className="text-white-75 font-weight-bolder font-size-sm"
                                style={{}}
                              >
                                Game
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 col-12 mb-3">
                          <div className="d-flex align-items-center mr-14">
                            <span className="mr-6">
                              <i
                                className="fa fa-gamepad text-muted"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </span>
                            <div className="d-flex flex-column flex-lg-fill text-white">
                              <div
                                className="text-white font-weight-bolder"
                                style={{ fontSize: "20px" }}
                              >
                                {contestData?.data?.matchTitle}
                              </div>
                              <span
                                className="text-white-75 font-weight-bolder font-size-sm"
                                style={{}}
                              >
                                Title
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 col-12 mb-3">
                          <div className="d-flex align-items-center mr-14">
                            <span className="mr-6">
                              {/* <i className="fonticon-telegram text-muted" style={{ fontSize: '25px' }}></i> */}
                              <i
                                className="far fa-calendar-check text-muted font-weight-bold"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </span>
                            <div className="d-flex flex-column flex-lg-fill text-white">
                              <div
                                className="text-white font-weight-bolder"
                                style={{ fontSize: "20px" }}
                              >
                                {contestData?.data?.countriesAryString}
                                {/* {contestData?.data?.countries?.value ||
                                            (contestData?.data && contestData?.data?.countries)} */}
                              </div>
                              <span
                                className="text-white-75 font-weight-bolder font-size-sm"
                                style={{}}
                              >
                                Country
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-xl-3 col-sm-6 col-12 mb-3">
                          <div className="d-flex align-items-center mr-14">
                            <span className="mr-6">
                              <i
                                className="far fa-calendar-check text-muted font-weight-bold"
                                style={{ fontSize: "25px" }}
                              ></i>
                            </span>
                            <div className="d-flex flex-column flex-lg-fill text-white">
                              <div
                                className="text-white font-weight-bolder"
                                style={{ fontSize: "20px" }}
                              >
                                {/* {console.log('date',contestData?.data?.date)}
                                            {console.log('time',contestData?.data?.time)}
                                            {console.log('mom',moment(contestData?.data?.date) .format('DD MMM YY hh:mmA'))} */}

                                {contestData?.data?.matchDate ? (
                                  <>
                                    {moment(
                                      contestData?.data?.matchDate
                                    ).format("MMM DD, YYYY")}{" "}
                                    {moment(
                                      contestData?.data?.matchTime
                                    ).format("hh:mm a")}
                                  </>
                                ) : (
                                  "-"
                                )}
                              </div>
                              <span
                                className="text-white-75 font-weight-bolder font-size-sm"
                                style={{}}
                              >
                                Contest Time
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-1 d-flex p-0">
                      <div className="d-flex align-items-center ml-auto">
                        <Accordion.Toggle
                          as={Button}
                          variant="link"
                          eventKey="1"
                        >
                          <i
                            className={`${
                              isShowSectionDetails
                                ? "fas fa-chevron-circle-up"
                                : "fas fa-chevron-circle-down"
                            } icon-2x text-light`}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setIsShowSectionDetails(!isShowSectionDetails);
                            }}
                          ></i>
                        </Accordion.Toggle>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="d-flex w-100 flex-column mt-4">
                  <div className="d-flex align-items-center justify-content-center w-100">
                    {/* <span className="font-weight-bold text-dark-75">Progress</span> */}
                    <div className="progress progress-xs w-100">
                      <div
                        className="progress-bar bg-warning"
                        role="progressbar"
                        style={{
                          width: `${parseInt(
                            allocatedUserList?.data?.length * 100
                          ) / parseInt(allocatedUserList?.data?.length)}%`,
                        }}
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    {/* <span className="font-weight-bolder text-dark">78%</span> */}
                  </div>

                  <div
                    className="d-flex align-items-center justify-content-between w-100"
                    style={{ fontSize: "12px", fontWeight: "600" }}
                  >
                    <div>{allocatedUserList?.data?.length} Joined Team</div>
                    <div>
                    {allocatedUserList?.data?.length} Remaining users
                      {/* {parseInt(
                        parseInt(contestData.data?.userCount) -
                          parseInt(contestData?.data?.totalJoinedPlayers || 0)
                      )}{" "}
                      Remaining users */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Accordion.Collapse eventKey="1">
              <div className="card-body p-0">
                <div
                  className="d-flex flex-column"
                  style={{ padding: "20px 20px 0 20px" }}
                >
                  <div className="d-flex mb-9">
                    {/* Details */}
                    <div className="flex-grow-1">
                      <div className="d-flex flex-wrap justify-content-between">
                        {/* Detail Box */}
                        <div className="d-flex flex-column flex-grow-1 pr-8">
                          {/* First Row */}
                          <div className="d-flex flex-wrap">
                            {contestData?.data?.titles &&
                              contestData?.data?.titles.map((value, i) => {
                                if (
                                  value?.isContest &&
                                  value?.name.trim() !== "-"
                                ) {
                                  return (
                                    <div
                                      className="rounded min-w-125px py-3 px-4 mr-3"
                                      style={{
                                        border:
                                          "1px dashed var(--color_color_input_text_border)",
                                        margin: "5px 0px",
                                      }}
                                      key={i}
                                    >
                                      <div className="row m-0 p-0">
                                        <i
                                          className="flaticon-chat-1 mr-2 font-size-lg"
                                          style={{
                                            fontSize: "30px",
                                            alignSelf: "center",
                                          }}
                                        ></i>
                                        <div className="col">
                                          <div
                                            className="fs-4 fw-bolder"
                                            style={{ fontSize: "16px" }}
                                          >
                                            {value[`title${i + 1}`] ||
                                              value.value}
                                          </div>
                                          <div
                                            className="font-weight-bold fs-6 text-gray-400"
                                            style={{
                                              color:
                                                "var(--color_border_color)",
                                            }}
                                          >
                                            {value.label || value.name}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}

                            {contestData?.data?.contestFor &&
                              contestData?.data?.contestFor.map((value, i) => {
                                return (
                                  <>
                                    <div
                                      className="rounded min-w-125px py-3 px-4 mr-3"
                                      style={{
                                        border:
                                          "1px dashed var(--color_color_input_text_border)",
                                        margin: "5px 0px",
                                      }}
                                      key={i}
                                    >
                                      <div className="row m-0 p-0">
                                        <i
                                          className="flaticon-piggy-bank mr-2 font-size-lg"
                                          style={{
                                            fontSize: "30px",
                                            alignSelf: "center",
                                          }}
                                        ></i>
                                        <div className="col">
                                          <div
                                            className="fs-4 fw-bolder"
                                            style={{ fontSize: "16px" }}
                                          >
                                            {value.inCurrency.label} -{" "}
                                            {value.outCurrency.label}
                                            {contestData?.data?.contestForAry &&
                                            contestData?.data?.contestForAry
                                              .length > 0
                                              ? ` (${contestData?.data?.contestForAry[i].code})`
                                              : ""}
                                          </div>
                                          <div
                                            className="font-weight-bold fs-6 text-gray-400"
                                            style={{
                                              color:
                                                "var(--color_border_color)",
                                            }}
                                          >
                                            In - Out Currency
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}

                            {/* <div
                                        className="rounded min-w-125px py-3 px-4 mr-3"
                                        style={{
                                            border:
                                            "1px dashed var(--color_color_input_text_border)",
                                            margin: "5px 0px",
                                        }}
                                        >
                                        <div className="row m-0 p-0">
                                            <i
                                            className="flaticon-star mr-2 font-size-lg"
                                            style={{
                                                fontSize: "30px",
                                                alignSelf: "center",
                                            }}
                                            ></i>
                                            <div className="col">
                                            <div
                                                className="fs-4 fw-bolder"
                                                style={{ fontSize: "16px" }}
                                            >
                                                {contestData?.contestRateAvg} (
                                                {contestData?.contestToatalRate})
                                            </div>
                                            <div
                                                className="font-weight-bold fs-6 text-gray-400"
                                                style={{
                                                color: "var(--color_border_color)",
                                                }}
                                            >
                                                Star Ratings
                                            </div>
                                            </div>
                                        </div>
                                        </div> */}

                            <div
                              className="rounded min-w-125px py-3 px-4 mr-3"
                              style={{
                                border:
                                  "1px dashed var(--color_color_input_text_border)",
                                margin: "5px 0px",
                              }}
                            >
                              <div className="row m-0 p-0">
                                <i
                                  className="fas fa-hashtag mr-2 font-size-lg"
                                  style={{
                                    fontSize: "30px",
                                    alignSelf: "center",
                                  }}
                                ></i>
                                <div className="col">
                                  <div className="fs-4 fw-bolder">
                                    {contestData?.data?.tournamentAry
                                      ?.shortCode || null}
                                  </div>
                                  <div
                                    className="font-weight-bold fs-6 text-gray-400"
                                    style={{
                                      color: "var(--color_border_color)",
                                    }}
                                  >
                                    Short Code
                                  </div>
                                </div>
                              </div>
                            </div>

                            {contestData?.data?.assignedContestUserData &&
                              contestData?.data?.assignedContestUserData
                                ?.name && (
                                <div
                                  className="rounded min-w-125px py-3 px-4 mr-3"
                                  style={{
                                    border:
                                      "1px dashed var(--color_color_input_text_border)",
                                    margin: "5px 0px",
                                  }}
                                >
                                  <div className="row m-0 p-0">
                                    <i
                                      className="flaticon2-user mr-2 font-size-lg"
                                      style={{
                                        fontSize: "30px",
                                        alignSelf: "center",
                                      }}
                                    ></i>
                                    <div className="col">
                                      <div className="fs-4 fw-bolder">
                                        {
                                          contestData?.data
                                            ?.assignedContestUserData?.name
                                        }
                                      </div>
                                      <div
                                        className="font-weight-bold fs-6 text-gray-400"
                                        style={{
                                          color: "var(--color_border_color)",
                                        }}
                                      >
                                        Assigned To
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                          </div>

                          {/* Second Row */}
                          <div className="d-flex flex-wrap">
                            <div
                              className="rounded min-w-125px py-3 px-4 mr-3"
                              style={{
                                border:
                                  "1px dashed var(--color_color_input_text_border)",
                                margin: "5px 0px",
                              }}
                            >
                              <div className="row m-0 p-0">
                                <i
                                  className="flaticon-confetti mr-2 font-size-lg"
                                  style={{
                                    fontSize: "30px",
                                    alignSelf: "center",
                                  }}
                                ></i>
                                <div className="col">
                                  <div className="fs-4 fw-bolder">
                                    {parseInt(
                                      contestData?.data?.tournamentAry?.entryFee
                                    ) === 0
                                      ? "Free"
                                      : contestData?.data?.tournamentAry
                                          ?.entryFee}
                                  </div>
                                  <div
                                    className="font-weight-bold fs-6 text-gray-400"
                                    style={{
                                      color: "var(--color_border_color)",
                                    }}
                                  >
                                    Entry Fee
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="rounded min-w-125px py-3 px-4 mr-3"
                              style={{
                                border:
                                  "1px dashed var(--color_color_input_text_border)",
                                margin: "5px 0px",
                              }}
                            >
                              <div className="row m-0 p-0">
                                <i
                                  className="flaticon2-cup mr-2 font-size-lg"
                                  style={{ fontSize: "30px" }}
                                ></i>
                                <div className="col">
                                  <div className="fs-4 fw-bolder">
                                    {contestData?.data?.tournamentAry
                                      ?.winningTerm === "perKill" ? (
                                      <>
                                        <>
                                          Type - Per Kill (
                                          {parseInt(
                                            contestData?.data?.tournamentAry
                                              ?.perKillPoints
                                          ) === 0
                                            ? 0
                                            : contestData?.data?.tournamentAry
                                                ?.perKillPoints}
                                          )
                                        </>
                                      </>
                                    ) : (
                                      createWinnersDropdown()
                                    )}
                                  </div>
                                  <div
                                    className="font-weight-bold fs-6 text-gray-400"
                                    style={{
                                      color: "var(--color_border_color)",
                                    }}
                                  >
                                    Winning Breakup
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              className="rounded min-w-125px py-3 px-4 mr-3"
                              style={{
                                border:
                                  "1px dashed var(--color_color_input_text_border)",
                                margin: "5px 0px",
                              }}
                            >
                              <div className="row m-0 p-0">
                                <i
                                  className="flaticon-piggy-bank mr-2 font-size-lg"
                                  style={{
                                    fontSize: "30px",
                                    alignSelf: "center",
                                  }}
                                ></i>
                                <div className="col">
                                  <div className="fs-4 fw-bolder">
                                    {
                                      contestData?.data?.tournamentAry
                                        ?.prizePool
                                    }
                                  </div>
                                  <div
                                    className="font-weight-bold fs-6 text-gray-400"
                                    style={{
                                      color: "var(--color_border_color)",
                                    }}
                                  >
                                    Prize Pool
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* <div
                                        className="rounded min-w-125px py-3 px-4 mr-3"
                                        style={{
                                            border:
                                            "1px dashed var(--color_color_input_text_border)",
                                            margin: "5px 0px",
                                        }}
                                        >
                                        <div className="row m-0 p-0">
                                            <i
                                            className="flaticon-network mr-2 font-size-lg"
                                            style={{
                                                fontSize: "30px",
                                                alignSelf: "center",
                                            }}
                                            ></i>
                                            <div className="col">
                                            <div className="fs-4 fw-bolder">
                                                {parseInt(
                                                parseInt(contestData?.data?.entryFee) *
                                                    parseInt(
                                                    contestData?.data?.totalJoinedPlayers
                                                    )
                                                )}{" "}
                                            </div>
                                            <div
                                                className="font-weight-bold fs-6 text-gray-400"
                                                style={{
                                                color: "var(--color_border_color)",
                                                }}
                                            >
                                                League Joining Revenue
                                            </div>
                                            </div>
                                        </div>
                                        </div> */}

                            {contestData?.data?.LJRCoin &&
                              contestData?.data?.LJRCoin.map((value, i) => {
                                return (
                                  <>
                                    <div
                                      className="rounded min-w-125px py-3 px-4 mr-3"
                                      style={{
                                        border:
                                          "1px dashed var(--color_color_input_text_border)",
                                        margin: "5px 0px",
                                      }}
                                      key={i}
                                    >
                                      <div className="row m-0 p-0">
                                        <i
                                          className="flaticon-network mr-2 font-size-lg"
                                          style={{
                                            fontSize: "30px",
                                            alignSelf: "center",
                                          }}
                                        ></i>
                                        <div className="col">
                                          <div
                                            className="fs-4 fw-bolder"
                                            style={{ fontSize: "16px" }}
                                          >
                                            {value.currencyName +
                                              "(" +
                                              value.amount +
                                              ")"}
                                          </div>
                                          <div
                                            className="font-weight-bold fs-6 text-gray-400"
                                            style={{
                                              color:
                                                "var(--color_border_color)",
                                            }}
                                          >
                                            League Joining Revenue 5
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}

                            <div
                              className="rounded min-w-125px py-3 px-4 mr-3"
                              style={{
                                border:
                                  "1px dashed var(--color_color_input_text_border)",
                                margin: "5px 0px",
                              }}
                            >
                              <div className="row m-0 p-0">
                                <i
                                  className="flaticon2-cup mr-2 font-size-lg"
                                  style={{ fontSize: "30px" }}
                                ></i>
                                <div className="col">
                                  <div className="fs-4 fw-bolder">
                                    {
                                      contestData?.data?.tournamentAry
                                        ?.totalActualWinners
                                    }
                                  </div>
                                  <div
                                    className="font-weight-bold fs-6 text-gray-400"
                                    style={{
                                      color: "var(--color_border_color)",
                                    }}
                                  >
                                    Actual Winner
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* <div
                                        className="rounded min-w-125px py-3 px-4 mr-3"
                                        style={{
                                            border:
                                            "1px dashed var(--color_color_input_text_border)",
                                            margin: "5px 0px",
                                        }}
                                        >
                                        <div className="row m-0 p-0">
                                            <i
                                            className="flaticon-pie-chart mr-2 font-size-lg"
                                            style={{
                                                fontSize: "30px",
                                                alignSelf: "center",
                                            }}
                                            ></i>
                                            <div className="col">
                                            <div className="fs-4 fw-bolder">
                                                {contestData?.data
                                                ?.totalWinningsDistributed ||
                                                contestData?.data
                                                    ?.totalWinningsDistributedCoin}
                                            </div>
                                            <div
                                                className="font-weight-bold fs-6 text-gray-400"
                                                style={{
                                                color: "var(--color_border_color)",
                                                }}
                                            >
                                                Winning Distributed
                                            </div>
                                            </div>
                                        </div>
                                        </div> */}

                            {contestData?.data?.LJRCoin &&
                              contestData?.data?.winningInfoCoin.map(
                                (value, i) => {
                                  return (
                                    <>
                                      <div
                                        className="rounded min-w-125px py-3 px-4 mr-3"
                                        style={{
                                          border:
                                            "1px dashed var(--color_color_input_text_border)",
                                          margin: "5px 0px",
                                        }}
                                        key={i}
                                      >
                                        <div className="row m-0 p-0">
                                          <i
                                            className="flaticon-pie-chart mr-2 font-size-lg"
                                            style={{
                                              fontSize: "30px",
                                              alignSelf: "center",
                                            }}
                                          ></i>
                                          <div className="col">
                                            <div
                                              className="fs-4 fw-bolder"
                                              style={{ fontSize: "16px" }}
                                            >
                                              {value.currencyName +
                                                "(" +
                                                value.amount +
                                                ")"}
                                            </div>
                                            <div
                                              className="font-weight-bold fs-6 text-gray-400"
                                              style={{
                                                color:
                                                  "var(--color_border_color)",
                                              }}
                                            >
                                              Winning Distributed
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  );
                                }
                              )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="separator separator-solid"></div>

                  <div className="d-flex align-items-center flex-wrap mt-4 mb-2">
                    <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                      <span className="mr-4">
                        <i className="fas fa-hashtag display-4 text-muted"></i>
                      </span>
                      <div className="d-flex flex-column flex-lg-fill">
                        <span className="text-dark-75 font-weight-bolder font-size-sm">
                          Room ID
                        </span>
                        <a className="text-primary font-weight-bolder">
                          {contestData?.data?.roomId || "-"}
                        </a>
                      </div>
                    </div>

                    <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                      <span className="mr-4">
                        <i className="flaticon-chat-1 display-4 text-muted font-weight-bold"></i>
                      </span>
                      <div className="d-flex flex-column">
                        <span className="text-dark-75 font-weight-bolder font-size-sm">
                          Password
                        </span>
                        <a className="text-primary font-weight-bolder">
                          {contestData?.data?.password || "-"}
                        </a>
                      </div>
                    </div>

                    <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                      <span className="mr-4">
                        <i className="flaticon-users-1 display-4 text-muted font-weight-bold"></i>
                      </span>
                      <div className="d-flex flex-column">
                        <span className="text-dark-75 font-weight-bolder font-size-sm">
                          Players
                        </span>
                        <a className="text-primary font-weight-bolder">
                          {contestData?.data?.numberOfPlayedUsers == 0
                            ? "need to update"
                            : contestData?.data?.numberOfPlayedUsers}
                        </a>
                      </div>
                    </div>

                    {contestData?.data?.rpUploadTime &&
                      contestData?.data?.status ===
                        UIHelpers.CONTEST_STATUS.completed && (
                        <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                          <span className="mr-4">
                            <i className="far fa-calendar-alt display-4 text-muted font-weight-bold"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-dark-75 font-weight-bolder font-size-sm">
                              RP Shared Time
                            </span>
                            <a className="text-primary font-weight-bolder">
                              {moment(contestData?.data?.rpUploadTime).format(
                                "lll"
                              )}
                            </a>
                          </div>
                        </div>
                      )}

                    {contestData?.data?.ssUploadTime &&
                      contestData?.data?.status ===
                        UIHelpers.CONTEST_STATUS.completed && (
                        <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                          <span className="mr-4">
                            <i className="far fa-calendar-alt display-4 text-muted font-weight-bold"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-dark-75 font-weight-bolder font-size-sm">
                              SS Upload Time
                            </span>
                            <a className="text-primary font-weight-bolder">
                              {moment(contestData?.data?.ssUploadTime).format(
                                "lll"
                              )}
                            </a>
                          </div>
                        </div>
                      )}

                    {contestData?.data?.updateWinningsTime &&
                      contestData?.data?.status ===
                        UIHelpers.CONTEST_STATUS.completed && (
                        <div className="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                          <span className="mr-4">
                            <i className="far fa-calendar-alt display-4 text-muted font-weight-bold"></i>
                          </span>
                          <div className="d-flex flex-column">
                            <span className="text-dark-75 font-weight-bolder font-size-sm">
                              Winnings Distributed Time
                            </span>
                            <a className="text-primary font-weight-bolder">
                              {moment(
                                contestData?.data?.updateWinningsTime
                              ).format("lll")}
                            </a>
                          </div>
                        </div>
                      )}
                    <></>
                  </div>
                </div>
              </div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      </div>
    );
  };

  return (
    <div className="">
      {createCardStats()}
      {createBasicDetails()}
    </div>
  );
}
